import { formatApiErrorDetail } from "@/lib/api";

export const errMsg = (e, d) => formatApiErrorDetail(e?.response?.data?.detail) || d;

export const PLAN_TONE = {
  Reseller: "bg-sky-50 text-sky-800 border-sky-200",
  "Service Provider": "bg-violet-50 text-violet-800 border-violet-200",
  UnitedCloud: "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Account Charges": "bg-amber-50 text-amber-800 border-amber-200",
};
const SHORT = { Reseller: "RES", "Service Provider": "SP", UnitedCloud: "UC", "Account Charges": "AC" };

export function PlanBadge({ plan }) {
  return (
    <span title={plan} className={`inline-flex w-9 shrink-0 justify-center rounded border px-1 py-px text-[10px] font-bold ${PLAN_TONE[plan] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
      {SHORT[plan] || "?"}
    </span>
  );
}

export function Criterion({ f, ops }) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-xs ${f.valid ? "border-slate-200 bg-white" : "border-red-200 bg-red-50"}`}>
      <span className="font-mono text-[11px] text-slate-500">{f.field}</span>
      <span className="text-slate-400">{ops[f.op] || f.op}</span>
      {f.value === "" ? <span className="italic text-slate-400">(empty)</span>
        : <span className="font-mono text-[11px] font-semibold text-slate-800">{f.value}</span>}
    </span>
  );
}

export function downloadBlob(blob, name) {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
